import AppInstructionsController from "@/controllers/model-controllers/app-instructions-controller"
import { provide } from "vue"
import { InitialDataController } from "@/controllers/initial-data-controller"
import OrderController from "@/controllers/order-controller"
import InstructionController from "@/controllers/model-controllers/instruction-controller"
import { ServiceProviderDateController } from "@/controllers/service-provider-date-controller"
import { MessageController } from "@/controllers/model-controllers/message-controller"
import { LayoutController } from "@/controllers/layout-controller"
import { LockController } from "@/controllers/lock-controller"
import { UserController } from "@/controllers/model-controllers/user-controller"
import { InstructionFeedbackController } from "@/controllers/model-controllers/instruction-feedback/instruction-feedback-controller"
import { HolidayController } from "@/controllers/model-controllers/holiday-controller"
import { KnownBusinessEntityContactController } from "@/controllers/model-controllers/known-business-entity-contact-controller"
import { ProjectController } from "@/controllers/model-controllers/project-controller"
import { PersonController } from "@/controllers/model-controllers/person-controller"
import { MachineController } from "@/controllers/model-controllers/machine-controller"
import { KnownBusinessEntityController } from "@/controllers/model-controllers/known-business-entity-controller.ts"
import { LocationController } from "@/controllers/model-controllers/location-controller"
import { AuthController } from "@/controllers/auth-controller"
import { FileController } from "@/controllers/file-controller"
import PurchaseController from "@/controllers/model-controllers/purchase-controller"
import SaleController from "@/controllers/model-controllers/sale-controller"
import RentalIntakeController from "@/controllers/model-controllers/rental-intake-controller"
import RentalDispenseController from "@/controllers/model-controllers/rental-dispense-controller"
import { ActivityController } from "@/controllers/model-controllers/activity-controller"
import { AppActivityController } from "@/controllers/model-controllers/app-activity-controller"
import { PurchaseItemController } from "@/controllers/model-controllers/purchase-item-controller"
import { PurchaseSurchargePeriodController } from "@/controllers/model-controllers/purchase-surcharge-period-controller"
import { SaleItemController } from "@/controllers/model-controllers/sale-item-controller"
import { RentalIntakeItemController } from "@/controllers/model-controllers/rental-intake-item-controller"
import { RentalDispenseItemController } from "@/controllers/rental-dispense-item-controller.ts"
import { KnownBusinessEntitySaleItemController } from "@/controllers/model-controllers/known-business-entity-sale-item-controller.ts"
import { ProjectSaleItemController } from "@/controllers/model-controllers/project-sale-item-controller"
import { ProjectPurchaseItemController } from "@/controllers/model-controllers/project-purchase-item-controller"
import { ProjectRentalIntakeItemController } from "@/controllers/model-controllers/project-rental-intake-item-controller"
import { ProjectRentalDispenseItemController } from "@/controllers/model-controllers/project-rental-dispense-item-controller"
import { KnownBusinessEntityRentalDispenseItemController } from "@/controllers/model-controllers/known-business-entity-rental-dispense-item-controller.ts"
import { InstructionFeedbackActivityController } from "@/controllers/model-controllers/instruction-feedback/instruction-feedback-activity-controller"
import { ProductController } from "@/controllers/model-controllers/product-controller"
import { AppProductController } from "@/controllers/model-controllers/app-product-controller"
import { InstructionFeedbackActivityProductController } from "@/controllers/model-controllers/instruction-feedback/instruction-feedback-activity-product-controller"
import { AppWorkPeriodController } from "@/controllers/model-controllers/app-work-period-controller.ts"
import { WorkPeriodController } from "@/controllers/model-controllers/work-period-controller"
import { RoleServiceProviderMachineController } from "@/controllers/model-controllers/role-service-provider-machine-controller.ts"
import { IncomingInvoiceController } from "@/controllers/model-controllers/incoming-invoice-controller"
import { IncomingInvoicePurchaseController } from "@/controllers/model-controllers/incoming-invoice-purchase-controller"
import { IncomingInvoiceRentalIntakeMaterializationController } from "@/controllers/model-controllers/incoming-invoice-rental-intake-materialization-controller"
import RentalIntakeMaterializationController from "@/controllers/model-controllers/rental-intake-materialization-controller.ts"
import { RentalDispenseMaterializationController } from "@/controllers/model-controllers/rental-dispense-materialization-controller"
import { AvailabilityBucketController } from "@/controllers/model-controllers/availability-bucket-controller.ts"
import { RecurringAvailabilityController } from "@/controllers/model-controllers/recurring-availability-controller.ts"
import { AvailabilityBlockController } from "@/controllers/model-controllers/availability-block-controller.ts"
import { AvailabilityReasonController } from "@/controllers/model-controllers/availability-reason-controller.ts"
import { WorkPeriodTemplateController } from "@/controllers/model-controllers/work-period-template-controller.ts"
import { WorkPeriodTemplateActivityController } from "@/controllers/model-controllers/work-period-template-activity-controller.ts"
import { InstructionFeedbackActivityTemplateController } from "@/controllers/model-controllers/instruction-feedback/instruction-feedback-activity-template-controller.ts"
import { InstructionFeedbackActivityTemplateProductController } from "@/controllers/model-controllers/instruction-feedback/instruction-feedback-activity-template-product-controller.ts"
import { ProductionStatementController } from "@/controllers/model-controllers/production-statement-controller"
import { WorkspaceNoteController } from "@/workspace/controllers/model-controllers/workspace-note-controller"
import { WorkspaceAudienceGroupController } from "@/workspace/controllers/model-controllers/workspace-audience-group-controller"
import { WorkspaceChecklistItemController } from "@/workspace/controllers/model-controllers/workspace-checklist-item-controller"
import { ProductionStatementApprovalController } from "@/controllers/model-controllers/production-statement-approval-controller"
import { OutgoingInvoiceController } from "@/controllers/model-controllers/outgoing-invoice-controller"
import { ProductionStatementApprovalAllocationController } from "@/controllers/model-controllers/production-statement-approval-allocation-controller"

export default function useControllers() {
  const authController = new AuthController()
  const fileController = new FileController()
  const holidayController = new HolidayController()
  const personController = new PersonController()
  const knownBusinessEntityContactController = new KnownBusinessEntityContactController()
  const layoutController = new LayoutController()
  const projectController = new ProjectController()
  const machineController = new MachineController()
  const knownBusinessEntityController = new KnownBusinessEntityController()
  const locationController = new LocationController()
  const purchaseItemController = new PurchaseItemController()
  const purchaseSurchargePeriodController = new PurchaseSurchargePeriodController()
  const saleItemController = new SaleItemController()
  const rentalIntakeItemController = new RentalIntakeItemController()
  const rentalDispenseItemController = new RentalDispenseItemController()
  const productController = new ProductController()
  const appProductController = new AppProductController()
  const appWorkPeriodController = new AppWorkPeriodController()
  const workPeriodController = new WorkPeriodController()
  const orderController = new OrderController()
  const availabilityReasonController = new AvailabilityReasonController()
  const workPeriodTemplateController = new WorkPeriodTemplateController()
  const workPeriodTemplateActivityController = new WorkPeriodTemplateActivityController()
  const instructionFeedbackActivityTemplateController =
    new InstructionFeedbackActivityTemplateController()
  const instructionFeedbackActivityTemplateProductController =
    new InstructionFeedbackActivityTemplateProductController()
  const workspaceNoteController = new WorkspaceNoteController()
  const workspaceAudienceGroupController = new WorkspaceAudienceGroupController()
  const workspaceChecklistItemController = new WorkspaceChecklistItemController(
    workspaceNoteController
  )

  const initialDataController = new InitialDataController({
    holidayController,
    personController,
    knownBusinessEntityContactController,
    projectController,
    machineController,
    knownBusinessEntityController,
    locationController,
    purchaseItemController,
    saleItemController,
    rentalIntakeItemController,
    rentalDispenseItemController,
    productController,
    appProductController,
    orderController,
    availabilityReasonController,
    workPeriodTemplateController,
    instructionFeedbackActivityTemplateController,
    workspaceNoteController,
    workspaceAudienceGroupController
  })
  const appInstructionsController = new AppInstructionsController()
  const instructionController = new InstructionController(orderController)
  const serviceProviderDateController = new ServiceProviderDateController()
  const messageController = new MessageController()
  const lockController = new LockController()
  const userController = new UserController()
  const instructionFeedbackController = new InstructionFeedbackController()
  const purchaseController = new PurchaseController()
  const saleController = new SaleController()
  const rentalIntakeController = new RentalIntakeController()
  const rentalDispenseController = new RentalDispenseController()
  const activityController = new ActivityController()
  const appActivityController = new AppActivityController()
  const projectPurchaseItemController = new ProjectPurchaseItemController()
  const projectSaleItemController = new ProjectSaleItemController()
  const projectRentalIntakeItemController = new ProjectRentalIntakeItemController()
  const projectRentalDispenseItemController = new ProjectRentalDispenseItemController()
  const knownBusinessEntitySaleItemController = new KnownBusinessEntitySaleItemController()
  const knownBusinessEntityRentalDispenseItemController =
    new KnownBusinessEntityRentalDispenseItemController()
  const instructionFeedbackActivityController = new InstructionFeedbackActivityController()
  const instructionFeedbackActivityProductController =
    new InstructionFeedbackActivityProductController()
  const roleServiceProviderMachineController = new RoleServiceProviderMachineController()
  const incomingInvoiceController = new IncomingInvoiceController()
  const incomingInvoicePurchaseController = new IncomingInvoicePurchaseController()
  const incomingInvoiceRentalIntakeMaterializationController =
    new IncomingInvoiceRentalIntakeMaterializationController()
  const rentalIntakeMaterializationController = new RentalIntakeMaterializationController()
  const rentalDispenseMaterializationController = new RentalDispenseMaterializationController()
  const availabilityBucketController = new AvailabilityBucketController()
  const recurringAvailabilityController = new RecurringAvailabilityController()
  const availabilityBlockController = new AvailabilityBlockController()
  const productionStatementController = new ProductionStatementController()
  const productionStatementApprovalController = new ProductionStatementApprovalController()
  const outgoingInvoiceController = new OutgoingInvoiceController()
  const productionStatementApprovalAllocationController =
    new ProductionStatementApprovalAllocationController()

  function provideControllers() {
    provide("authController", authController)
    provide("fileController", fileController)
    provide("holidayController", holidayController)
    provide("projectController", projectController)
    provide("machineController", machineController)
    provide("knownBusinessEntityController", knownBusinessEntityController)
    provide("personController", personController)
    provide("knownBusinessEntityContactController", knownBusinessEntityContactController)
    provide("locationController", locationController)
    provide("layoutController", layoutController)
    provide("initialDataController", initialDataController)
    provide("appInstructionsController", appInstructionsController)
    provide("orderController", orderController)
    provide("instructionController", instructionController)
    provide("serviceProviderDateController", serviceProviderDateController)
    provide("messageController", messageController)
    provide("lockController", lockController)
    provide("userController", userController)
    provide("instructionFeedbackController", instructionFeedbackController)
    provide("purchaseController", purchaseController)
    provide("saleController", saleController)
    provide("rentalIntakeController", rentalIntakeController)
    provide("rentalDispenseController", rentalDispenseController)
    provide("activityController", activityController)
    provide("appActivityController", appActivityController)
    provide("purchaseItemController", purchaseItemController)
    provide("purchaseSurchargePeriodController", purchaseSurchargePeriodController)
    provide("saleItemController", saleItemController)
    provide("rentalIntakeItemController", rentalIntakeItemController)
    provide("rentalDispenseItemController", rentalDispenseItemController)
    provide("knownBusinessEntitySaleItemController", knownBusinessEntitySaleItemController)
    provide("projectSaleItemController", projectSaleItemController)
    provide("projectPurchaseItemController", projectPurchaseItemController)
    provide("projectRentalIntakeItemController", projectRentalIntakeItemController)
    provide("projectRentalDispenseItemController", projectRentalDispenseItemController)
    provide(
      "knownBusinessEntityRentalDispenseItemController",
      knownBusinessEntityRentalDispenseItemController
    )
    provide("instructionFeedbackActivityController", instructionFeedbackActivityController)
    provide(
      "instructionFeedbackActivityProductController",
      instructionFeedbackActivityProductController
    )
    provide("productController", productController)
    provide("appProductController", appProductController)
    provide("appWorkPeriodController", appWorkPeriodController)
    provide("workPeriodController", workPeriodController)
    provide("roleServiceProviderMachineController", roleServiceProviderMachineController)
    provide("incomingInvoiceController", incomingInvoiceController)
    provide("incomingInvoicePurchaseController", incomingInvoicePurchaseController)
    provide(
      "incomingInvoiceRentalIntakeMaterializationController",
      incomingInvoiceRentalIntakeMaterializationController
    )
    provide("rentalIntakeMaterializationController", rentalIntakeMaterializationController)
    provide("rentalDispenseMaterializationController", rentalDispenseMaterializationController)
    provide("availabilityBucketController", availabilityBucketController)
    provide("recurringAvailabilityController", recurringAvailabilityController)
    provide("availabilityBlockController", availabilityBlockController)
    provide("productionStatementController", productionStatementController)
    provide("productionStatementApprovalController", productionStatementApprovalController)
    provide("outgoingInvoiceController", outgoingInvoiceController)
    provide(
      "productionStatementApprovalAllocationController",
      productionStatementApprovalAllocationController
    )
    provide("workPeriodTemplateController", workPeriodTemplateController)
    provide("workPeriodTemplateActivityController", workPeriodTemplateActivityController)
    provide(
      "instructionFeedbackActivityTemplateController",
      instructionFeedbackActivityTemplateController
    )
    provide(
      "instructionFeedbackActivityTemplateProductController",
      instructionFeedbackActivityTemplateProductController
    )
    provide("workspaceNoteController", workspaceNoteController)
    provide("workspaceAudienceGroupController", workspaceAudienceGroupController)
    provide("workspaceChecklistItemController", workspaceChecklistItemController)
  }

  function getAuthController() {
    return authController
  }

  return {
    provideControllers,
    getAuthController
  }
}
